import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Navigate } from "react-router-dom";
import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class UpdateAboutUs extends Component {
  state = {
    id: "",
    title: "",
    description: "",
    message: "",
    notification: false,
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    if (id) {
      this.setState({ id });
      this.getSingleAboutUs(id);
    }
  }

  getSingleAboutUs = async (id) => {
    try {
      if (init() !== "success") {
        this.setState({ redirect: true });
        return;
      }

      const resp = await axios.get(Constants.getUrls.getAboutUs + "/" + id);

      this.setState({
        title: resp.data.data.title || "",
        description: resp.data.data.description || "",
      });
    } catch (error) {
      console.error(error);
      this.showSnackbar("Error fetching About Us data");
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (init() !== "success") {
      this.setState({ redirect: true });
      return;
    }

    this.setState({ loading: true });

    const payload = {
      title: this.state.title,
      description: this.state.description,
    };

    axios
      .put(Constants.putUrls.updateAboutUs + this.state.id, payload)
      .then((resp) => {
        this.setState({
          notification: true,
          message: resp.data.message || "About Us updated successfully",
          loading: false,
        });

        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
            redirect: true,
          });
        }, 2000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message: err?.response?.data?.message || "Error updating About Us",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 4000);
      });
  };

  showSnackbar = (message) => {
    this.setState({
      notification: true,
      message,
    });

    setTimeout(() => {
      this.setState({ notification: false, message: "" });
    }, 3000);
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/aboutus" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update About Us
              </MDTypography>
            </MDBox>

            {/* FORM */}
            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* TITLE */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      required
                    />
                  </Grid>

                  {/* DESCRIPTION */}
                  <Grid item xs={12}>
                    <MDTypography variant="button" fontWeight="medium" mb={1}>
                      About Us Description
                    </MDTypography>

                    <SunEditor
                      setDefaultStyle="font-family: Arial; font-size: 16px;"
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["bold", "italic", "underline"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link"],
                          ["removeFormat"],
                        ],
                      }}
                      setContents={this.state.description}
                      onChange={this.handleDescription}
                    />
                  </Grid>
                </Grid>

                <MDBox mt={2}>
                  <MDButton
                    variant="contained"
                    color="info"
                    type="submit"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Updating..." : "Update"}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            {/* SNACKBAR */}
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Fabinov | About Us"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
